import { Tooltip } from "@material-ui/core"
import PendingIcon from "@material-ui/icons/CachedOutlined"
import PassedIcon from "@material-ui/icons/CheckCircleOutline"
import FailedIcon from "@material-ui/icons/HighlightOffOutlined"
import NoActionIcon from "@material-ui/icons/RemoveCircleOutline"
import React from "react"
import { DEVICE_UPDATE_STATUS } from "../../constants"
import { DATA_SCOPES, FILTER_TYPE } from "../filterConstants"
import { DateFilter } from "../filterTypes/dateFilter"
import { ElementFilter } from "../filterTypes/elementFilter"
import { ListFilter } from "../filterTypes/listFilter"
import { NumberFilter } from "../filterTypes/numberFilter"
import { StringFilter } from "../filterTypes/stringFilter"

export class OverallUpdateStatusFilter extends ElementFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Overall Status",
      FILTER_TYPE.UPDATES.OVERALL_STATUS,
      [DATA_SCOPES.UPDATES],
      null,
      visibility,
      restrictedToScope,
    )
  }

  formatData(_device, _deviceGroups, _insight, _insightMetrics, update, _alert) {
    const status = update.status
    const dataMap = {}
    switch (status) {
      case DEVICE_UPDATE_STATUS.SUCCESS:
        dataMap.element = (
          <Tooltip title={"Device update passed"}>
            <PassedIcon style={{ color: "green" }} />
          </Tooltip>
        )
        dataMap.orderValue = 1
        break
      case DEVICE_UPDATE_STATUS.FAILED:
        dataMap.element = (
          <Tooltip title={"Device update failed"}>
            <FailedIcon style={{ color: "red" }} />
          </Tooltip>
        )
        dataMap.orderValue = 2
        break
      case DEVICE_UPDATE_STATUS.PENDING:
        dataMap.element = (
          <Tooltip title={"Device update pending"}>
            <PendingIcon style={{ color: "#ebc934" }} />
          </Tooltip>
        )
        dataMap.orderValue = 3
        break
      default:
        dataMap.element = (
          <Tooltip title={"No current or past device updates"}>
            <NoActionIcon style={{ color: "grey" }} />
          </Tooltip>
        )
        dataMap.orderValue = 4
        break
    }
    return dataMap
  }
}

export class FirmwareVersionFilter extends StringFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Firmware Version",
      FILTER_TYPE.UPDATES.FIRMWARE_VERSION,
      [DATA_SCOPES.UPDATES],
      "Firmware Version Tag. Actual version sha changes.",
      visibility,
      restrictedToScope,
    )
  }

  formatData(_device, _deviceGroups, _insight, _insightMetrics, update, _alert) {
    return update.firmwareReleaseTag
  }
}

export class AlgReleaseIdFilter extends NumberFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Alg Release",
      FILTER_TYPE.UPDATES.ALG_RELEASE_ID,
      [DATA_SCOPES.UPDATES],
      null,
      visibility,
      restrictedToScope,
    )
  }

  formatData(_device, _deviceGroups, _insight, _insightMetrics, update, _alert) {
    return update.algReleaseId
  }
}

export class UpdateIdFilter extends NumberFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Update ID",
      FILTER_TYPE.UPDATES.ID,
      [DATA_SCOPES.UPDATES],
      null,
      visibility,
      restrictedToScope,
    )
  }

  formatData(_device, _deviceGroups, _insight, _insightMetrics, update, _alert) {
    return update.deviceUpdateId
  }
}

export class UpdateCycleTimeFilter extends NumberFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Cycle Time",
      FILTER_TYPE.UPDATES.CYCLE_TIME,
      [DATA_SCOPES.UPDATES],
      null,
      visibility,
      restrictedToScope,
    )
  }

  formatData(_device, _deviceGroups, _insight, _insightMetrics, update, _alert) {
    return update.cycleTime
  }
}

export class UpdateTriggerNumberFilter extends NumberFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Trigger Number",
      FILTER_TYPE.UPDATES.TRIGGER_NUMBER,
      [DATA_SCOPES.UPDATES],
      null,
      visibility,
      restrictedToScope,
    )
  }

  formatData(_device, _deviceGroups, _insight, _insightMetrics, update, _alert) {
    return update.triggerNumber
  }
}

export class DeviceCountFilter extends NumberFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Device Count",
      FILTER_TYPE.UPDATES.DEVICE_COUNT,
      [DATA_SCOPES.UPDATES],
      null,
      visibility,
      restrictedToScope,
    )
  }

  formatData(_device, _deviceGroups, _insight, _insightMetrics, update, _alert) {
    return update.deviceIds.length
  }
}

export class CreatedOnFilter extends DateFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Created On (UTC)",
      FILTER_TYPE.UPDATES.CREATED_ON,
      [DATA_SCOPES.UPDATES],
      null,
      visibility,
      restrictedToScope,
    )
  }

  formatData(_device, _deviceGroups, _insight, _insightMetrics, update, _alert) {
    return update.createdAt
  }
}

export class DeviceIdsFilter extends ListFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Device IDs",
      FILTER_TYPE.UPDATES.DEVICE_IDS,
      [DATA_SCOPES.UPDATES],
      null,
      visibility,
      restrictedToScope,
    )
  }

  formatData(_device, _deviceGroups, _insight, _insightMetrics, update, _alert) {
    return update.deviceIds.map((device) => device.deviceId.toString())
  }
}
